// Jemný teplý přechod mezi sekcemi – tenká měděná linie a světelná záře
// inspirovaná grafikou obálky e-booku.

export const WarmDivider = ({ from, to }) => (
  <div
    aria-hidden="true"
    className="relative h-16 sm:h-24"
    style={{ background: `linear-gradient(180deg, ${from} 0%, ${to} 100%)` }}
  >
    <div
      className="absolute inset-0"
      style={{
        background:
          "radial-gradient(60% 140% at 50% 50%, rgba(201,127,82,0.22), transparent 70%)",
      }}
    />
    <div
      className="absolute inset-0"
      style={{
        background:
          "radial-gradient(30% 90% at 50% 50%, rgba(166,90,58,0.16), transparent 75%)",
      }}
    />
    <div
      className="absolute inset-x-0 top-1/2 h-px"
      style={{
        background:
          "linear-gradient(90deg, transparent 10%, rgba(201,127,82,0.6), transparent 90%)",
      }}
    />
  </div>
);
